import { extendObservable } from 'mobx';

class HardwareModel {
    constructor(session) {
        this._session = session;
        extendObservable(this, {
            macaddr: '',
            hardwaretype: '',
            ipamtype: '',
            sdused: '',
            sdusedpercent: '',
            sdsize: '',
            filesystem: '',
            fsstatus: '',
            errorNetwork: true
        });
    }

    async load() {
        console.log('HardwareModel: loading...');

        try {
            const settings = await this._session.rpc('call', [
                '',
                'barix_webui',
                'status_get_all',
                {}
            ]);

            if (settings === 500) {
                Object.assign(this, {
                    errorNetwork: true
                });
            } else {
                const settingobj = {
                    macaddr: settings[1].mac_lan,
                    hardwaretype: settings[1].hw_type,
                    ipamtype: settings[1].ipam_type,
                    sdused: settings[1].fsinfo_data.used,
                    sdusedpercent: settings[1].fsinfo_data.percent,
                    sdsize: settings[1].fsinfo_data.total,
                    filesystem: settings[1].fsinfo_data.type,
                    fsstatus: settings[1].fsinfo_data.status,
                    errorNetwork: false
                };

                Object.assign(this, settingobj);
            }
        } catch (err) {
            console.error('HardwareModel: ' + err);
        }

        console.log('HardwareModel: loaded');
    }

    getErrorNetwork() {
        return this.errorNetwork;
    }
}

export default HardwareModel;



// WEBPACK FOOTER //
// ./src/models/HardwareModel.js